import { useContext, useState } from "react";
import { ReactComponent as Visibility } from "../../../../assets/img/icon/visibility_black_24dp.svg";
import { ReactComponent as VisibilityOff } from "../../../../assets/img/icon/visibility_off_black_24dp.svg";
import { dbmToPercentage, getSignalLabel } from "../../../../helpers/helper";
import { getRequest as getRequestServer } from "../../../../services/httpService/axiosRequest";
import {
  getRequest,
  postRequest,
} from "../../../../services/localService/localService";
import { setDeviceWifiValidator } from "../../../../validators/DeviceValidator";
import { GlobalContext } from "../../../contexts/globalContext";

const ModalDeviceSetWifi = (props) => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [state, setState] = useState({
    step: 0,
    ssid: "",
    password: "",
    isHidden: true,
    scannedSsid: [],
  });

  const getSsidList = async () => {
    try {
      let result = await getRequest("/scan-wifi");
      result = result.map((res) => {
        res.strength = dbmToPercentage(res.strength);
        const strengthLabel = getSignalLabel(res.strength);
        return { ...res, strengthLabel };
      });
      setState((prevState) => ({
        ...prevState,
        scannedSsid: result,
      }));
    } catch (error) {
      console.log(error.message);
    }
  };

  const checkConnection = async () => {
    try {
      dispatch("isLoading", true);
      await getRequest("");
      dispatch("isLoading", false);
      setState((prevState) => ({ ...prevState, step: prevState.step + 1 }));
      getSsidList();
    } catch (error) {
      dispatch("isLoading", false);
      dispatch("alert", {
        message:
          "Anda belum terhubung dengan perangkat respinos. Periksa kembali koneksi perangkat anda dengan respinos.",
        type: "warning",
        show: true,
      });
    }
  };

  const generateErrorMessage = (error) => {
    let message;
    switch (error.message) {
      case "timeout of 20000ms exceeded":
        message =
          "Pengaturan wifi gagal dilakukan, silakan periksa kembali koneksi perangkat anda ke respinos";
        break;
      case "Network Error":
        message = "Ada kesalahan jaringan, silakan periksa wifi anda.";
        break;
      default:
        message = error.message;
        break;
    }
    return message;
  };

  const postWifiConf = async () => {
    try {
      if (state.ssid === "") throw new Error("Nama Wifi tidak boleh kosong");
      if (state.password === "") throw new Error("Password tidak boleh kosong");

      const { error } = await setDeviceWifiValidator({
        ssid: state.ssid,
        password: state.password,
      });
      if (error) throw new Error(error.details[0].message);

      dispatch("isLoading", true);
      let response = await postRequest("/set-wifi", {
        ssid: state.ssid,
        password: state.password,
      });

      response = await getRequest("");
      dispatch("isLoading", false);
      if (response.network === "Connected") {
        dispatch("alert", {
          message: `Perangkat sudah terhubung ke internet melalui jaringan ${state.ssid}. Silakan hubungkan laptop/smartphone anda ke jaringan internet.`,
          type: "success",
          show: true,
        });
        setState((prevState) => ({ ...prevState, step: prevState.step + 1 }));
      } else {
        dispatch("alert", {
          message: `Gagal menghubungkan ke "${state.ssid}". Periksa kembali nama ssid wifi beserta passwordnya.`,
          type: "warning",
          show: true,
        });
      }
    } catch (error) {
      dispatch("isLoading", false);
      const message = generateErrorMessage(error);
      dispatch("alert", {
        message: message,
        type: "warning",
        show: true,
      });
    }
  };

  const checkServer = async (input) => {
    try {
      dispatch("isLoading", true);
      await getRequestServer("");
      dispatch("isLoading", false);
      props.handleClose(input);
    } catch (error) {
      dispatch("isLoading", false);
      dispatch("alert", {
        message:
          "Sepertinya anda belum terhubung ke internet. Silakan nyalakan paket data atau hubungkan ke wifi.",
        type: "warning",
        show: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handlePrevious = () => {
    if (state.step === 0) {
      window.alert(
        "Pastikan anda sudah terhubung kembali pada jaringan internet!"
      );
      setState({
        step: 0,
        ssid: "",
        password: "",
        scannedSsid: [],
      });
      checkServer();
      // props.handleClose();
    } else if (state.step > 0) {
      setState((prevState) => ({ ...prevState, step: prevState.step - 1 }));
    }
  };

  const handleNext = () => {
    switch (state.step) {
      case 1:
        checkConnection();
        break;
      case 2:
        setState((prevState) => ({ ...prevState, isHidden: true }));
        postWifiConf();
        break;
      case 3:
        checkServer(props.device._id);
        break;
      default:
        setState((prevState) => ({ ...prevState, step: prevState.step + 1 }));
        break;
    }
  };

  let content = null;
  switch (state.step) {
    case 0:
      content = (
        <div>
          <p>
            Anda memasuki mode konfigurasi Perangkat Respinos. Mode ini
            digunakan untuk mengatur konfigurasi jaringan perangkat "
            {props.device._id}" sehingga bisa terhubung dengan internet.
          </p>
          <div className="mt-5 bg-gray-800 rounded-lg p-1">
            Perhatian : Pada saat melakukan konfigurasi jaringan, jangan
            merefresh/reload halaman ini.
          </div>
        </div>
      );
      break;
    case 1:
      content = (
        <div>
          Silakan pindai perangkat "{props.device._id}" dengan menggunakan wifi
          HP/Laptop anda, kemudian hubungkanlah. Gunakan token pada perangkat
          sebagai password.
        </div>
      );
      break;
    case 2:
      content = (
        <>
          <div>
            Masukan SSID dan password wifi yang tersedia pada jaringan anda:
          </div>
          <div className="mt-3">
            <div>
              <div>Wifi</div>
              <input
                className="mt-0.5 w-full rounded px-2 py-1 focus:outline-none focus:ring-2 bg-gray-800 "
                type="text"
                name="ssid"
                value={state.ssid}
                onChange={handleChange}
                list="scannedSsid"
              />
              <datalist id="scannedSsid">
                {state.scannedSsid.map((scanned) => (
                  <option
                    key={"scannedSsid" + scanned.name}
                    value={scanned.name}
                  >
                    {scanned.name}{" "}
                    {scanned.strengthLabel && `- ${scanned.strengthLabel}`}
                  </option>
                ))}
              </datalist>
            </div>
            <div className="mt-2">
              <div>Password</div>
              <div className="relative">
                <div
                  className="absolute right-2 top-2 cursor-pointer"
                  onClick={() =>
                    setState((prevState) => ({
                      ...prevState,
                      isHidden: !prevState.isHidden,
                    }))
                  }
                >
                  {state.isHidden ? (
                    <VisibilityOff className="w-5 h-5 fill-current text-gray-300" />
                  ) : (
                    <Visibility className="w-5 h-5 fill-current text-gray-300" />
                  )}
                </div>
                <input
                  className="mt-0.5 w-full rounded px-2 py-1 focus:outline-none focus:ring-2 bg-gray-800"
                  type={state.isHidden ? "password" : "text"}
                  name="password"
                  value={state.password}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </>
      );
      break;

    case 3:
      content = (
        <div>
          Selamat anda sudah berhasil menghubungkan perangkat {props.device._id}{" "}
          dengan jaringan internet. Sekarang hubungkan kembali gadget anda
          dengan paket data atau wifi.
        </div>
      );
      break;

    default:
      break;
  }
  return (
    <div className="absolute top-0 left-0 right-0 bottom-0 bg-gray-500 z-20 p-2">
      <div className="text-sm sm:text-base max-w-xl mx-auto mt-20 bg-gray-700 text-white shadow-lg rounded-2xl p-3 md:p-5 relative pb-16">
        <div style={{ minHeight: "200px" }}>{content}</div>

        <div className="absolute left-0 bottom-3 md:bottom-5 w-full">
          <div className="flex justify-between px-3 md:px-5">
            <button
              className={
                "px-1.5 w-20 rounded-md bg-warning text-white focus:outline-none focus:ring-2 " +
                (state.step === 3 ? "cursor-not-allowed" : "cursor-pointer")
              }
              onClick={handlePrevious}
              disabled={state.step === 3}
            >
              {state.step === 0 ? "Batal" : "Kembali"}
            </button>
            <button
              className="px-1.5 w-20 rounded-md bg-primary text-white focus:outline-none focus:ring-2"
              onClick={handleNext}
            >
              Lanjut
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDeviceSetWifi;
